import { renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "padding10px break-word text-align-left" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", {
  class: "el-icon-my-q",
  style: {"cursor":"pointer"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")

  return (_openBlock(), _createBlock("div", {
    class: ['display-inline-block', _ctx.selfClass]
  }, [
    _createVNode(_component_el_popover, {
      placement: _ctx.placement,
      width: 220,
      trigger: "hover"
    }, {
      reference: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["placement"])
  ], 2))
}